module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-address":"Update Address","address-updated":"Address updated","failed-update-address":"Failed to update address","create-address":"Create Address","address-created":"Address created","failed-create-address":"Failed to create address"}}')
  delete Component.options._Ctor
}
